module.exports = __webpack_public_path__ + "static/media/2_pl.8e856dd7.png";